import BaseXMLGenerator from './xlsx-tableexport-generator.js';

var XMLGenerator = new BaseXMLGenerator();
XMLGenerator.baseGenerate = XMLGenerator.generate
XMLGenerator.generate = function (vm, datas) {
    var rows = []
    for (var data of datas) {
        var row = []
        row.push(data.Name)
        rows.push(row)
    }
    let headerList = ['Name']
    return this.baseGenerate(rows, headerList)
}

export default XMLGenerator;